/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import ExpandDetails from '../ExpandDetails.vue';

const __vue_script__ = {
    name: 'PersonSessionStats',

    components: { ExpandDetails },

    props: {
        eid: {
            type: String,
            required: true,
        },

        fpExtId: {
            type: String,
            required: true,
        }
    },

    data() {
        return {
            registeredSessions: [],
            targetedSessions: [],
        };
    },

    async mounted() {
        this.registeredSessions = await this.getSessions('registered');
        this.targetedSessions = await this.getSessions('targeted');
    },

    methods: {
        /** @param {'registered'|'targeted'} */
        async getSessions(type) {
            const sessionsModule = this.$services.blueprint.getModuleByName('sessions');
            const sessions = await this.$services.appScripts.callAppScript(
                this.eid,
                `agenda/get-${type}-sessions-for-user`,
                { pid: this.fpExtId },
            );
            return sessions.map(d => ({
                label: d.name || d.title || d.fp_ext_id,
                href: this.$utils.modules.getRouteHref(sessionsModule, 'view', { eventId: this.eid, _id: d._id })
            }));
        }
    },
};

/* template */
var __vue_render__ = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "person-sessions-stats" },
    [
      _c(
        "expand-details",
        {
          scopedSlots: _vm._u([
            {
              key: "summary",
              fn: function () {
                return [
                  _c("span", [
                    _c("span", [
                      _vm._v(
                        _vm._s(_vm.$t("user_display.registered_sessions"))
                      ),
                    ]),
                    _c("span", { staticClass: "badge info" }, [
                      _vm._v(_vm._s(_vm.registeredSessions.length)),
                    ]),
                  ]),
                ]
              },
              proxy: true,
            },
          ]),
        },
        [
          _vm.registeredSessions.length
            ? _c(
                "ul",
                _vm._l(_vm.registeredSessions, function (d) {
                  return _c("li", [
                    _c("a", { attrs: { href: d.href, title: d.label } }, [
                      _vm._v(_vm._s(d.label)),
                    ]),
                  ])
                }),
                0
              )
            : _vm._e(),
        ]
      ),
      _c(
        "expand-details",
        {
          scopedSlots: _vm._u([
            {
              key: "summary",
              fn: function () {
                return [
                  _c("span", [
                    _c("span", [
                      _vm._v(_vm._s(_vm.$t("user_display.targeted_sessions"))),
                    ]),
                    _c("span", { staticClass: "badge info" }, [
                      _vm._v(_vm._s(_vm.targetedSessions.length)),
                    ]),
                  ]),
                ]
              },
              proxy: true,
            },
          ]),
        },
        [
          _vm.targetedSessions.length
            ? _c(
                "ul",
                _vm._l(_vm.targetedSessions, function (d) {
                  return _c("li", [
                    _c("a", { attrs: { href: d.href, title: d.label } }, [
                      _vm._v(_vm._s(d.label)),
                    ]),
                  ])
                }),
                0
              )
            : _vm._e(),
        ]
      ),
    ],
    1
  )
}
var __vue_staticRenderFns__ = []
__vue_render__._withStripped = true

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "apps/shared/src/ui/components/fp-type-display/PersonSessionStats.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__